import { useTranslation } from 'react-i18next';
import {hapticFeedbackImpactOccurred, shareURL} from '@telegram-apps/sdk-react';

import { SystemModalContainer } from '@/components/common/SystemModal/SystemModal.tsx';
import { MainButton } from '@/components/common/MainButton/MainButton.tsx';
import { TonChallenge } from '@/api/ton/types.ts';
import { helpers } from '@/helpers.ts';
import { MessageTypesUI } from '@/enums/viewEnums.ts';
import { Toast } from '@/components/Toast/Toast.tsx';
import {
  containerStyle,
  contentStyle,
  noteContainerStyle,
  noteTextStyle,
  textContainerStyle,
  textStyle
} from '@/components/EarnTon/Challenges/UnlockBonusesPopup/styles.ts';
import MoneyDollarShape from '@/components/common/svg/shapes/MoneyDollarShape.tsx';
import InfoShape from '@/components/common/svg/shapes/InfoShape.tsx';

type InviteFriendPopupProps = {
  challengeData: TonChallenge;
  handleClose: () => void;
};

const InviteFriendPopup = ({
  challengeData,
  handleClose
}: InviteFriendPopupProps) => {
  const { t } = useTranslation();

  const handleShareLink = () => {
    const funnelId = challengeData.invite_friend_body?.funnel_id;
    shareURL(
      funnelId
        ? `https://t.me/KyivDateBot?start=${funnelId}`
        : 'https://t.me/KyivDateBot'
    );
    handleClose();
  };

  const handleCopyLink = () => {
    const funnelId = challengeData.invite_friend_body?.funnel_id;
    void navigator.clipboard.writeText(
      funnelId
        ? `https://t.me/KyivDateBot?start=${funnelId}`
        : 'https://t.me/KyivDateBot'
    );
    hapticFeedbackImpactOccurred('rigid');
    helpers.toast({
      id: MessageTypesUI.TYPE_SYSTEM_INFO,
      content: (
        <Toast
          type={MessageTypesUI.TYPE_SYSTEM_INFO}
          msg={t('earn.challenge.copy_to_clipboard')}
        />
      )
    });
    handleClose();
  };

  return (
    <SystemModalContainer headerTitle="" handleClose={handleClose}>
      <div style={containerStyle}>
        <div style={contentStyle}>
          <MoneyDollarShape width={70} height={70} fillColor="#000" />
          <div style={{ ...textContainerStyle, marginBottom: 20 }}>
            <p style={textStyle}>{t('earn.challenge.invite_friend_text')}</p>
            <div
              style={{ ...noteContainerStyle, marginTop: 0, marginBottom: 20 }}
            >
              <InfoShape width={40} height={40} fillColor="#000" />
              <p style={noteTextStyle}>
                {t('earn.challenge.invite_friend_note')}
              </p>
            </div>
          </div>
        </div>
      </div>
      <MainButton
        onClick={handleShareLink}
        text={t('earn.challenge.share_ref_link')}
      />
      <MainButton onClick={handleCopyLink} text={t('button.copy')} />
      <MainButton
        onClick={handleClose}
        text={t('button.close')}
        buttonStyle={{
          background: 'transparent',
          color: '#000'
        }}
      />
    </SystemModalContainer>
  );
};

export default InviteFriendPopup;
